import { Autocomplete, Button, Card, Dialog, DialogContent, DialogTitle, Divider, Grid, IconButton, Slide, TextField } from "@mui/material";
import { IconCircleX } from "@tabler/icons-react";
import { IconAdjustmentsHorizontal, IconX } from "@tabler/icons-react";
import { removeEmptyKeys } from "helper/encodeData";
import React, { forwardRef, useEffect, useState } from "react";
import { connect } from "react-redux";
import { getRegionOption } from "store/app/farm-management/farm-records/actions";
import { setStateFilteredData } from "store/app/form-management/state-configuration/actions";
import { unionBy } from 'lodash';
import VWDropdown from "components/dropdown";

const regionStatusOption = [
    { label: "Active", value: true },
    { label: "Inactive", value: false },
]
const styles = {
    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
        display: "none",
    },
    "& input[type=number]": {
        MozAppearance: "textfield",
    },
}

const Transition = forwardRef((props, ref) => <Slide direction="left" ref={ref} {...props} />);

const FilterRegion = (props) => {

    const { open, onClose, stateFilterData } = props;

    const [isAutoOpenRegionStatus, setIsAutoOpenRegionStatus] = useState();
    const [filter, setFilter] = useState();

    //--------------------Region---------------------------
    const [regionOptions, setRegionOptions] = useState([]);

    const loadRegionOption = (filter, page, pageSize) => {
        return props.getRegionOption(filter, "filter", page, pageSize)
    }

    useEffect(() => {
        if (stateFilterData) {
            setFilter(stateFilterData);
        }
        else {
            setFilter(null);
        }
    }, [open]);

    const validateOnchange = (e) => {
        const { name, value } = e.target;
        setFilter({
            ...filter,
            [name]: value,
        });
    }
    const handleSelect = (option, name) => {
        const { label } = option || {};
        setFilter({
            ...filter,
            [name]: label,
        });
    }

    const handleMultiSelect = (options, name) => {
        const optionArray = options?.map((field) => field.label ? field.label : field);
        const optionString = optionArray?.length > 0 ? optionArray.join() : null;
        setFilter({
            ...filter,
            [name]: optionString,
        });
    }

    const handleFilter = (e) => {
        e.preventDefault();
        onClose();
        const nonEmptyData = removeEmptyKeys(filter);
        console.log("nonEmptyData: ", nonEmptyData);
        props.setStateFilteredData(nonEmptyData);
    }

    const handleFilterClear = (e) => {
        e.preventDefault();
        onClose();
        props.setStateFilteredData();
    }

    const validateClose = (e, reason) => {
        if (reason !== 'backdropClick') {
            onClose();
        }
    }
    return (
        <>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                maxWidth={'md'}
                fullWidth
                keepMounted
                onClose={validateClose}
                sx={{
                    '&>div:nth-of-type(3)': {
                        justifyContent: 'flex-end',
                        '&>div': {
                            m: 0,
                            borderRadius: '10px 0px 0px 10px',
                            maxWidth: 450,
                            maxHeight: '100%'
                        }
                    }
                }}
            >
                {open && (
                    <>
                        <Card sx={{ overflow: 'auto' }} >
                            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", pt: 0, pb: 0 }}>
                                Filters
                                <IconButton
                                    aria-label="close"
                                    onClick={onClose}
                                >
                                    <IconX />
                                </IconButton>
                            </DialogTitle>
                            <Divider />
                            <DialogContent>
                                <form>
                                    <Grid container rowGap={4} marginTop={2}>
                                        <Grid container rowGap={4} direction="column">
                                            <Grid item>
                                                <TextField
                                                    autoFocus
                                                    label="State/Export Name"
                                                    fullWidth
                                                    size="small"
                                                    name='statename'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={filter?.statename}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <VWDropdown
                                                    label="Region Name"
                                                    name="regionname"
                                                    multiple={true}
                                                    // disablePortal={true}
                                                    getOptions={loadRegionOption}
                                                    onSelect={handleMultiSelect}
                                                    // isOptionEqualToValue={(option, value) => option?.value === value?.value}
                                                    isOptionEqualToValue={(option, value) => option?.label?.toLowerCase() === value?.toLowerCase()}
                                                    selectedOption={filter?.regionname ? filter.regionname.includes(",") ? filter.regionname.split(",") : [filter.regionname] : []}
                                                    options={regionOptions}
                                                    setOptions={(options) => {
                                                        setRegionOptions((prev) => unionBy(prev, options, "value"));
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <TextField
                                                    sx={styles}
                                                    label="Assigned Users Count"
                                                    fullWidth
                                                    size="small"
                                                    name='asignedsusercount'
                                                    type='number'
                                                    onChange={validateOnchange}
                                                    value={filter?.asignedsusercount}
                                                    onKeyDown={
                                                        (e) => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
                                                    }
                                                />
                                            </Grid>
                                            <Grid item>
                                                <Autocomplete
                                                    size="small"
                                                    disablePortal
                                                    options={regionStatusOption}
                                                    open={isAutoOpenRegionStatus}
                                                    onOpen={() => setIsAutoOpenRegionStatus(true)}
                                                    onClose={() => setIsAutoOpenRegionStatus(false)}
                                                    onChange={(e, option) => handleSelect(option, 'regionstatus')}
                                                    value={filter?.regionstatus}
                                                    renderInput={(params) =>
                                                        <TextField
                                                            {...params}
                                                            label="Region Status"
                                                        />
                                                    }
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container justifyContent={'right'}>
                                            <Button
                                                variant="contained"
                                                onClick={handleFilter}
                                                size="small"
                                                color="primary"
                                                startIcon={<IconAdjustmentsHorizontal />}
                                            >
                                                Apply Filters
                                            </Button>
                                            <Button
                                                variant="contained"
                                                onClick={handleFilterClear}
                                                sx={{ ml: 2 }}
                                                color='error'
                                                size="small"
                                                startIcon={<IconCircleX />}
                                            >
                                                Clear
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            </DialogContent>
                        </Card>
                    </>
                )
                }

            </Dialog >

        </>
    )
}

const mapStateToProps = (state) => ({
    stateFilterData: state.states.stateFilterData,
})
const mapDispatchToProps = (dispatch) => ({
    setStateFilteredData: (filter) => dispatch(setStateFilteredData(filter)),
    getRegionOption: (filter, type, page, pageSize) => dispatch(getRegionOption(filter, type, page, pageSize)),
})

export default connect(mapStateToProps, mapDispatchToProps)(FilterRegion);